import {
  StoryblokComponent,
  StoryblokComponentType,
} from '@storyblok/react'
import React from 'react'

import { DefaultPage } from '@definitions/types/storyblokTypes'
import { editable } from '@helper/storyblokEditable'

const StoryblokPage = (props: DefaultPage) => {
  const blok = props.blok as DefaultPage
  const body = blok.body as StoryblokComponentType<string>[] | undefined

  return (
    <div {...editable(blok)} key={blok._uid} data-test="page">
      {body?.map((item) => (
        <StoryblokComponent key={item._uid} blok={item} />
      ))}
    </div>
  )
}

export default StoryblokPage
